// extracted by mini-css-extract-plugin
export default {"Button":"invalid-config-error-module__Button--spMDD"};